var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-svg"},[_c('ThumbUp'),_c('ThumbDown'),_c('Favorite'),_c('Fire'),_c('Mood')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }